/**
 * クリア済みステージの早送り導線 `Skip Stage`（TK-055、FR-026、`04-architecture.md` skip（shell））。
 *
 * 進捗（`zp.progress`）でクリア済みと判定できるステージ（そのシリーズの前線 `done` が
 * `stageNo` 以上）でのみ、画面下部に次ステージへの通常のリンクを出す。解いたことのある
 * 画像へ頭から解き直さずに再挑戦するための早送りで、スキップは進捗を更新せず、
 * 完成画像・クリア演出も見せない（ただのページ遷移であり、構造的にそうなる）。
 *
 * 判定は純関数 `skipTarget` に置き、DOM への適用だけを `attachSkipLink` が受け持つ。
 * `localStorage` 不可・進捗なし・破損時は「出ない」に落ちるだけで、プレイは従来どおり
 * （プログレッシブエンハンスメント）。
 */

import type { ProgressMap } from './progress';

/** `skipTarget` が見る埋め込み設定の面（`05` §3）。 */
export interface SkipConfig {
  readonly series: string;
  readonly stageNo: number;
  readonly next?: string;
  readonly isLast: boolean;
}

/**
 * スキップ先 URL。出さない場合は null。
 *
 * - 末尾ステージ（`next` なし）では出さない（FR-026）
 * - 進捗が無い・前線（`done`）が `stageNo` 未満なら出さない
 * - シリーズクリア済みなら全ステージが対象
 */
export function skipTarget(config: SkipConfig, progress: ProgressMap): string | null {
  if (config.isLast || config.next === undefined) return null;
  const series = progress[config.series];
  if (series === undefined) return null;
  if (!series.cleared && series.done < config.stageNo) return null;
  return config.next;
}

/** 下部導線帯へ `Skip Stage` リンクを追加する。クリア後に取り除くためハンドルを返す。 */
export function attachSkipLink(outbound: HTMLElement, href: string): HTMLAnchorElement {
  const link = document.createElement('a');
  link.className = 'skip-stage';
  link.href = href;
  link.textContent = 'Skip Stage';
  outbound.append(link);
  return link;
}
